import {entities} from '../../../api/proto';

export default function compareTariffId(tariff?: entities.ITariff | null, id?: string | null): boolean {
  return tariff?.id === id || !!(id && tariff?.name && tariff?.name.toLowerCase().indexOf(id) >= 0);
}